import React, { Component } from 'react';
import { connect } from 'react-redux';
import UserQuestion from './UserQuestion';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('USER_QUESTIONS_GROUP', LOG_LEVELS.DEBUG);

class UserQuestionGroup extends Component {

  render() {
    log.debug('render(): ', this.props);  
    const userQuestions = this.props.userQuestions || [];

    return (
      <div>
        <fieldset>
          {this.props.groupName ? (<h2>{this.props.groupName}</h2>):("")}
          {userQuestions.map((question, key) => (
            <s-row>
              <s-col span="6">
                <UserQuestion
                  key={key}
                  question={question}
                  answer={this.props.answers[question.BoxID] || ''}
                  filingTypeId={this.props.filingTypeId}
                  onFieldChange={this.props.onFieldChangeHandlerFactory(question.BoxID).bind(this)}
                />
              </s-col>
            </s-row>
          ))}
        </fieldset>
        <div className="clear"></div>
        <hr className="mt20 mb20" />
      </div>
    );
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {

  return {
    languages: state.languages
  };
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(UserQuestionGroup);
